import React from 'react';
import { Flex, Spinner, Subheading } from '@contentful/forma-36-react-components';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";

var Loader = function Loader(_ref) {
  var text = _ref.text,
      _ref$padding = _ref.padding,
      padding = _ref$padding === void 0 ? 'none' : _ref$padding,
      _ref$margin = _ref.margin,
      margin = _ref$margin === void 0 ? 'none' : _ref$margin;
  return /*#__PURE__*/_jsxs(Flex, {
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    margin: margin,
    padding: padding,
    children: [/*#__PURE__*/_jsx(Spinner, {
      color: "primary",
      size: "large"
    }), text && /*#__PURE__*/_jsx(Flex, {
      marginTop: "spacingS",
      children: /*#__PURE__*/_jsx(Subheading, {
        children: text
      })
    })]
  });
};

export default Loader;